import React from 'react';
import styles from './OptionSlider.module.scss';
import cn from 'classnames';
import _ from 'lodash';
import {useTranslation} from 'react-i18next';

const OptionSlider = ({
    options,
    vertical,
    label,
    className,
    width,
    onChange,
    value,
    defaultColor,
    error,
    onBlur,
    textClassName,
}) => {
    const {t} = useTranslation();
    if (!options.length) return;
    const betweenMargin = width / options.length;
    const sliderWrapper = cn(styles.optionSlider, className, {[styles.vertical]: vertical});
    const labelWrapper = cn(styles.label, {[styles.errorLabel]: error});
    const indexOfSelected = options.indexOf(value);
    return (
        <div className={sliderWrapper}>
            {label && <div className={labelWrapper}>{label}</div>}
            <div className={styles.optionsList}>
                {options.map((option, index) => {
                    return (
                        <div
                            className={cn(styles.option, {
                                [styles.selected]: index <= indexOfSelected,
                                [styles.target]: index === indexOfSelected,
                            })}
                            style={{'--slide-width': `${betweenMargin}rem`, '--default-color': defaultColor}}
                            onClick={() => {
                                onChange(option);
                                onBlur();
                            }}
                            key={option}
                        >
                            <span className={textClassName}>{t(option)}</span>
                        </div>
                    );
                })}
            </div>
            {error && <div className={cn(styles.error)}>{error}</div>}
        </div>
    );
};

OptionSlider.defaultProps = {
    width: 20,
    onChange: _.noop,
    defaultColor: '#f3f3f4',
    onBlur: _.noop,
};

export default OptionSlider;
